export default __webpack_public_path__ + "static/media/car_icon_focus.6264c562.svg";